import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@shahi-analytics/backend-utils';
import { DayLineWiseCompletedGarmentsModel, DayLineWiseCompletedGarmentsResponse, HourWiseDowntimeModel, HourWiseEfficiencyModel, HourWiseGarmentsModel, HourWiseReworkModel, LineDowntimeModel, LineDowntimeResponse, LineEfficiencyModel, LineOperationCompletionModel, LineOperationEfficiencyModel, LineOperationEfficiencyResponse, LineOperatorsModel, LineOperatorsReworkModel, LineOpportunityOperationsModel, LineOpportunityOperationsResponse, LineSmvModel, LineSmvResponse, LineTargetEffRequest, LineWiseGarmentsModel, LineWorkStationEfficiencyModel, LineWorkStationReworkModel, LineWorkStationReworkResponse, LineWorkstationEfficiencyResponse, LinesInUnitModel, LinesInUnitResponse, LinesReworkModel, OperationCompletionModel, OperationCompletionResponse, OperationEfficiencyModel, OperationReworkModel, OperationSmvModel, OperationTimeConsModel, OperatorReworkModel, OperatorReworkResponse, OpportunityOperationWorkstationModel, OpportunityOperationsModel, PlannedActualRejGarmentsModel, PlannedActualRejGarmentsResponse, ReasonWiseDowntimeModel, StyleModel, StyleOperationsTimeConsModel, StyleOperationsTimeConsResponse, StyleSmvModel, StylesResponse, WorkstationDowntimeModel, WorkstationEfficiencyModel, WorkstationLevelGarmentsCompletion, WorkstationReworkModel } from '@shahi-analytics/shared-models';
import { In, Repository } from 'typeorm';
import { LineEntity } from '../entities/line.entity';
import { OperationEntity } from '../entities/operation.entity';
import { OperatorEntity } from '../entities/operator.entity';
import { ReasonEntity } from '../entities/reason.entity';
import { StyleOperationsEntity } from '../entities/style-operations.entity';
import { StyleEntity } from '../entities/style.entity';
import { LineActualDayTrackEntity } from '../entities/transactions/line-actual-track.entity';
import { LineDownTimeEntity } from '../entities/transactions/line-down-time.entity';
import { LineEfficiencyDayTrackEntity } from '../entities/transactions/line-efficiency.entity';
import { LineDayPlanEntity } from '../entities/transactions/line-plan';
import { OperatorEfficiencyDayTrackEntity } from '../entities/transactions/operator-efficiency-track.entity';
import { WorkstationEntity } from '../entities/workstation.entity';
import { UnitLineDateRequest } from './request/unit-line-date.request';
import { MigrationHelperService } from '../migration/migration-helper.service';
import { InaHelperService } from './ina.helper.service';
import { UnitEntity } from '../entities/unit.entity';
import { LineTargetEffEntity } from '../entities/line-target-eff.entity';
import { UnitLineDateRangeRequest } from './request/unit-lins-date-range.request';
import { from } from 'rxjs';
import { UnitDateHourRequest } from '../migration/models/unit-date-hour.request';

@Injectable()
export class InaService {
  private unitShiftHours = [9, 10, 11, 12, 13, 14, 15, 16];

  constructor(
    @InjectRepository(LineActualDayTrackEntity) private lineActualDayTrackEnt: Repository<LineActualDayTrackEntity>,
    @InjectRepository(StyleEntity) private styleEnt: Repository<StyleEntity>,
    @InjectRepository(UnitEntity) private unitEnt: Repository<UnitEntity>,
    @InjectRepository(LineEntity) private lineEnt: Repository<LineEntity>,
    @InjectRepository(LineDayPlanEntity) private linePlanEnt: Repository<LineDayPlanEntity>,
    @InjectRepository(StyleOperationsEntity) private styleOpEnt: Repository<StyleOperationsEntity>,
    @InjectRepository(OperationEntity) private operationEnt: Repository<OperationEntity>,
    @InjectRepository(OperatorEfficiencyDayTrackEntity) private operatorEffEnt: Repository<OperatorEfficiencyDayTrackEntity>,
    @InjectRepository(WorkstationEntity) private workEnt: Repository<WorkstationEntity>,
    @InjectRepository(LineEfficiencyDayTrackEntity) private lineEffEnt: Repository<LineEfficiencyDayTrackEntity>,
    @InjectRepository(OperatorEntity) private operatorEnt: Repository<OperatorEntity>,
    @InjectRepository(LineDownTimeEntity) private downTimeEntity: Repository<LineDownTimeEntity>,
    @InjectRepository(ReasonEntity) private reasonEntity: Repository<ReasonEntity>,
    @InjectRepository(LineTargetEffEntity) private lineTargetEffEnt: Repository<LineTargetEffEntity>,
    private migHelperService: MigrationHelperService,
    private inaHelperService: InaHelperService
  ) { }


  /**
   * 1
   * get the total planned, total good, total rejected garments - hour wise, style wise, line wise
   * @param req 
   * @returns 
   */
  async getGarmentsPlanAndActualInfo(req: UnitLineDateRequest): Promise<PlannedActualRejGarmentsResponse> {
    const todayOutputsQuery = this.linePlanEnt.createQueryBuilder('ldp')
      .select(' ldp.hour, ldp.line_id, GROUP_CONCAT(DISTINCT act.style_id) as style_ids, SUM( if(is_last_op = true ,good_quantity, 0) ) as good_quantity, SUM(rejected_quantity) as rejected_quantity')
      .leftJoin(LineActualDayTrackEntity, 'act', 'ldp.unit_id = act.unit_id AND ldp.plan_date = act.plan_date AND ldp.line_id = act.line_id AND ldp.hour = act.hour')
      .where(` ldp.unit_id = '${req.unit}' AND ldp.plan_date = '${req.date}' AND (is_rework = false OR is_rework is null)`)
      .groupBy('ldp.unit_id, ldp.plan_date, ldp.line_id')
    if (req.isGroupByHour) {
      todayOutputsQuery.addGroupBy('ldp.hour');
    }
    todayOutputsQuery.orderBy('act.unit_id, act.plan_date,act.hour, act.line_id');
    const todayOutputsResult: { hour: number, line_id: string, style_ids: string, good_quantity: number, rejected_quantity: number }[] = await todayOutputsQuery.getRawMany();
    if (todayOutputsResult.length == 0) {
      throw new ErrorResponse(0, 'No garments summary found');
    }
    // console.log(todayOutputsResult);


    // get the line wise operators
    const lineOperatorsQuery = await this.lineActualDayTrackEnt.createQueryBuilder('ld')
      .select(' hour, line_id, style_id, operator_id')
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' `)
      .groupBy('unit_id, plan_date, line_id, style_id, operator_id')
    if (req.isGroupByHour) {
      lineOperatorsQuery.addGroupBy('hour');
    }
    lineOperatorsQuery.orderBy('unit_id, plan_date, hour, line_id');
    const lineOperatorResult: { hour: number, line_id: string, style_id: string, operator_id: string }[] = await lineOperatorsQuery.getRawMany();

    const lineStyleOperatorsCount = new Map<string, Set<string>>();
    const lineOperatorsCount = new Map<string, Map<number, Set<string>>>();
    lineOperatorResult.forEach(r => {
      const hour = req.isGroupByHour ? r.hour : 1;

      // const key = hour + '@' + r.style_id + '@' + r.line_id;
      const key = hour + '@' + r.line_id;
      if (!lineStyleOperatorsCount.has(key)) {
        lineStyleOperatorsCount.set(key, new Set<string>());
      }
      if (!lineOperatorsCount.has(r.line_id)) {
        lineOperatorsCount.set(r.line_id, new Map<number, Set<string>>());
      }
      if (!lineOperatorsCount.get(r.line_id).has(hour)) {
        lineOperatorsCount.get(r.line_id).set(hour, new Set<string>());
      }
      lineStyleOperatorsCount.get(key).add(r.operator_id);
      lineOperatorsCount.get(r.line_id).get(hour).add(r.operator_id);
    });

    const lineOpModels: LineOperatorsModel[] = [];
    lineOperatorsCount.forEach((hourOperators, l) => {
      hourOperators.forEach((operators, hour) => {
        lineOpModels.push(new LineOperatorsModel(l, operators?.size, hour));
      })
    });

    // get the distinct style ids, line ids 
    const styleIds = new Set<string>();
    const lineIds = new Set<string>();
    todayOutputsResult.forEach(rec => {
      const styleIdsArray = rec.style_ids?.split(',') ?? [];
      if(styleIdsArray.length > 0) {
        styleIdsArray.forEach(s => styleIds.add(s));
      }
      lineIds.add(rec.line_id);
    });
    const stylesInfo = await this.inaHelperService.getStyleInfo(req.unit, Array.from(styleIds));
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit, Array.from(lineIds));
    const hourWisePlanGtmsMap = await this.inaHelperService.getPlantQuantitiesHourWise(req.unit, Array.from(lineIds), req.date);
    const buyersInfo = await this.inaHelperService.getBuyerInfo(req.unit, Array.from(styleIds), req.date);

    const lineWiseGmtInfo = new Map<number, LineWiseGarmentsModel[]>(); // hour -> LineWiseGarmentsModel
    const hourWiseGmtInfo = new Map<number, HourWiseGarmentsModel>(); // hour -> HourWiseGarmentsModel
    let totalGmtPlanned = 0;

    hourWisePlanGtmsMap.forEach(lines => {
      lines.forEach(hourQty => {
        totalGmtPlanned += hourQty;
      });
    });
    // console.log(hourWisePlanGtmsMap);

    //  get the workstation level completed quantities for the line
    const lineWorkstationLevelCompletionMap = new Map<string, Map<number,WorkstationLevelGarmentsCompletion[]>>();
    const workstationLevelQtyQuery = this.lineActualDayTrackEnt.createQueryBuilder('ladt')
      .select(' hour, line_id, style_id, SUM(good_quantity) as good_quantity, SUM(rejected_quantity) as rejected_quantity, workstation_id, operation_id, actual_spent_time,operation_smv')
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' AND is_rework = false`)
      .groupBy('unit_id, plan_date, line_id, style_id, workstation_id')
    if (req.isGroupByHour) {
      workstationLevelQtyQuery.addGroupBy('hour');
    }
    workstationLevelQtyQuery.orderBy('unit_id, plan_date, hour, line_id, style_id, workstation_id');
    const workstationLevelQtyResult: { hour: number, line_id: string, style_id: string, good_quantity: number, rejected_quantity: number, workstation_id: string, operation_id: string, actual_spent_time: number, operation_smv: number }[] = await workstationLevelQtyQuery.getRawMany();
    workstationLevelQtyResult.forEach(w => {
      w.good_quantity = Number(w?.good_quantity);

      if (!lineWorkstationLevelCompletionMap.has(w.line_id)) {
        lineWorkstationLevelCompletionMap.set(w.line_id, new Map<number,WorkstationLevelGarmentsCompletion[]>());
      }
      if (!lineWorkstationLevelCompletionMap.get(w.line_id).has(w.hour)){
        lineWorkstationLevelCompletionMap.get(w.line_id).set(w.hour, []);
      }
      
      const hour = req.isGroupByHour ? w.hour : 1;
      let plannedGmt = 0;
      if (req.isGroupByHour) {
        // plannedGmt = planQtyInfo.get(w.line_id)?.get(w.style_id)?.get(hour);
        plannedGmt = hourWisePlanGtmsMap.get(w.line_id)?.get(hour) ?? 0;
      } else {
        plannedGmt = totalGmtPlanned;
      }

      if (!lineWiseGmtInfo.has(hour)) {
        lineWiseGmtInfo.set(hour, []);
        hourWiseGmtInfo.set(hour, new HourWiseGarmentsModel(hour, 0, 0, 0, []));
      }
      const planCompletionTime = w.good_quantity * w.operation_smv;
      const wInfo = new WorkstationLevelGarmentsCompletion(w.workstation_id, '', plannedGmt, w.good_quantity, planCompletionTime, w.actual_spent_time, w.operation_id);
      lineWorkstationLevelCompletionMap.get(w.line_id).get(hour).push(wInfo);
    })

    let totalGmtCompleted = 0;
    let totalGmtRejected = 0;

    todayOutputsResult.forEach(rec => {
      rec.good_quantity = Number(rec.good_quantity);
      rec.rejected_quantity = Number(rec.rejected_quantity);

      const hour = req.isGroupByHour ? rec.hour : 1;
      const styleIdsArray = rec.style_ids?.split(',') ?? [];
      const lastStyle = styleIdsArray.length > 0 ? styleIdsArray[styleIdsArray.length-1] : '0';
      const styleDesc = stylesInfo.get(rec.line_id)?.get(lastStyle)?.styleDesc;
      const lineDesc = linesInfo.get(rec.line_id)?.lineDesc;
      const buyer = buyersInfo.get(lastStyle);

      let plannedGmt = 0;
      if (req.isGroupByHour) {
        plannedGmt = hourWisePlanGtmsMap.get(rec.line_id)?.get(hour) ?? 0;
      } else {
        plannedGmt = totalGmtPlanned;
      }

      if (!lineWiseGmtInfo.has(hour)) {
        lineWiseGmtInfo.set(hour, []);
        hourWiseGmtInfo.set(hour, new HourWiseGarmentsModel(hour, 0, 0, 0, []));
      }

      // const key = hour + '@' + rec.style_id + '@' + rec.line_id;
      const key = hour + '@' + rec.line_id;
      // const operatorCount = lineStyleOperatorsCount?.get(key)?.size;
      const operatorCount = lineStyleOperatorsCount?.get(key)?.size;
      const workstationLevelQtys = lineWorkstationLevelCompletionMap?.get(rec.line_id)?.get(hour);
      lineWiseGmtInfo.get(hour).push(new LineWiseGarmentsModel(rec.line_id, lineDesc, plannedGmt, rec.good_quantity, styleIdsArray[0], styleDesc, buyer, rec.rejected_quantity, operatorCount, hour, workstationLevelQtys)); // TODO


      // setting the accumulation for HourWiseGarmentsModel
      hourWiseGmtInfo.get(hour).completedGarments += rec.good_quantity;
      hourWiseGmtInfo.get(hour).rejectedGarments += rec.rejected_quantity;
      hourWiseGmtInfo.get(hour).plannedGarments += plannedGmt;

      // setting the accumulation for PlannedActualRejGarmentsModel
      totalGmtCompleted += rec.good_quantity;
      totalGmtRejected += rec.rejected_quantity;
    });

    const hourWiseGarments: HourWiseGarmentsModel[] = [];
    hourWiseGmtInfo.forEach((rec, hour) => {
      rec.linesWiseGarments = lineWiseGmtInfo.get(hour);
      hourWiseGarments.push(rec);
    });

    // get the line targetEfficiencies for the day
    const lineEffs = await this.getLineTargetEfficienciesForDate(req.date, req.unit);
    const response = new PlannedActualRejGarmentsModel(req.unit, req.date, req.clientId, totalGmtPlanned, totalGmtCompleted, lineEffs, lineOpModels, hourWiseGarments);
    
    return new PlannedActualRejGarmentsResponse(true, 0, 'Garments completion status received', response);
  }


  async getLineTargetEfficienciesForDate(date: string, unitId: string): Promise<LineTargetEffRequest[]> {
    const lineTargetEffMap = new Map<string, number>();
    // now get all the llines in the unit
    const linesInUnit = await this.lineEnt.find({select: ['lineId'], where: { unitId: unitId }});
    linesInUnit.forEach(r => {
      lineTargetEffMap.set(r.lineId, 0);
    });

    const lineEffObjects: LineTargetEffRequest[] = [];
    // first get the styles running in the current date 
    const runningStyleInLines: {style_ids: string, line_id: string}[] = await this.lineActualDayTrackEnt.createQueryBuilder('ladt')
    .select(`DISTINCT line_id, GROUP_CONCAT(DISTINCT style_id) as style_ids`)
    .where(` unit_id = '${unitId}' AND plan_date = '${date}' `)
    .groupBy(` line_id `)
    .getRawMany();
    for(const line of runningStyleInLines) {
      const stylesArray = line.style_ids.split(',');
      const lastStyle = stylesArray[stylesArray.length-1];
      const styleRec = await this.styleEnt.findOne({ select: ['targetEff', 'styleName', 'styleId'], where: { unitId: unitId, styleId: lastStyle, lineId: line.line_id}});
      const currLineEff = styleRec?.targetEff ?  Number(styleRec.targetEff) : 0;
      lineTargetEffMap.set(line.line_id, currLineEff);
    }

    lineTargetEffMap.forEach((eff, line) => {
      lineEffObjects.push(new LineTargetEffRequest(unitId, line, eff, date));
    });
    return lineEffObjects;
  }

  async getLineTargetEfficienciesForDateOld(date: string, unitId: string): Promise<LineTargetEffRequest[]> {
    const lineEffObjects: LineTargetEffRequest[] = [];
    // first get the styles running in the current date 
    const runningStyleInLines: {style_id: string, line_id: string}[] = await this.lineActualDayTrackEnt.createQueryBuilder('ladt')
    .select(`DISTINCT line_id, style_id`)
    .where(` unit_id = '${unitId}' AND plan_date = '${date}' `)
    .groupBy(` line_id `)
    .getRawMany();
    const currentDayLineStylesMap = new Map<string, string>();
    runningStyleInLines.forEach(r => {
      currentDayLineStylesMap.set(r.line_id, r.style_id);
    });

    const lineTargetEffMap = new Map<string, number>();
    // now find the diff between the today upload eff vs the previous available ones
    const linesInUnit = await this.lineEnt.find({select: ['lineId'], where: { unitId: unitId }});
    linesInUnit.forEach(r => {
      lineTargetEffMap.set(r.lineId, 0);
    });
    
    // now get the current day target effs. If for any line, the target eff is not found, then get the previous eff from the history data
    const todayTargetEffs = await this.lineTargetEffEnt.find({ select: ['lineId', 'efficiency'], where: { planDate: date, unitId: unitId, isActive: true}});
    todayTargetEffs.forEach(r => {
      lineTargetEffMap.set(r.lineId, r.efficiency);
    });
    
    for(const lineRec of linesInUnit) {
      if(lineTargetEffMap.get(lineRec.lineId) == 0) {
        // get the pre eff from the line day target eff table
        const preStyle = currentDayLineStylesMap.get(lineRec.lineId);
        const targetEffRec = await this.lineTargetEffEnt.findOne({select: ['efficiency'], where: { unitId: unitId, lineId: lineRec.lineId, styleId: preStyle }, order: { id: "DESC" } });
        lineTargetEffMap.set(lineRec.lineId, targetEffRec?.efficiency ?? 0);
      }
    }

    lineTargetEffMap.forEach((eff, line) => {
      lineEffObjects.push(new LineTargetEffRequest(unitId, line, eff, date));
    });
    return lineEffObjects;
  }


  /**
   * 
   * @param unitId 
   * @param styleIds 
   */
  async getOperationsForStyle(unitId: string, styleIds: string[]): Promise<Map<string, Map<string, { opId: string, opCode: string, opOrder: number, smv: number }[]>>> {
    const opMap = new Map<string, Map<string, any[]>>();
    const operations = await this.styleOpEnt.find({ select: ['lineId', 'styleId', 'styleName', 'operationCode', 'operationId', 'operationSmv'], where: { unitId: unitId, styleId: In(styleIds) }, order: { operationOrder: 'ASC' } });
    operations.forEach(rec => {
      if (!opMap.has(rec.lineId)) {
        opMap.set(rec.lineId, new Map<string, []>());
      }
      if (!opMap.get(rec.lineId).has(rec.styleId)) {
        opMap.get(rec.lineId).set(rec.styleId, []);
      }
      opMap.get(rec.lineId).get(rec.styleId).push({ opId: rec.operationId, opCode: rec.operationCode, opOrder: rec.operationOrder, smv: rec.operationSmv });
    });
    return opMap;
  }




  /**
   * gets the plan and actual qtys for the unit + specific line or all lines and given date range
   * @param req 
   * @returns 
   */
  async getLineActualAndPlanQtysForDateRange(req: UnitLineDateRangeRequest): Promise<DayLineWiseCompletedGarmentsResponse> {
    const fromDate = req.fromDate;
    const toDate = req.toDate;
    const unit = req.unit;
    const lineId = req.lineId;
    if(!unit || !fromDate || !toDate) {
      throw new ErrorResponse(0, 'Provide unit, from date and to date');
    }
    
    const planQtys = await this.getPlanQtyDayWiseForDateRange(fromDate, toDate, unit);
    console.log(planQtys);
    const stylesInUnit = await this.styleEnt.find({ select: ['styleId', 'styleName'], where: { unitId: unit}});
    const stylesMap = new Map<string, string>();
    stylesInUnit.forEach(r => stylesMap.set(r.styleId, r.styleName));

    const dateLineWiseQtys = new Map<string, LineWiseGarmentsModel[]>();
    let linesInUnit: LineEntity[] = [];
    //If line is not passed, then we will get the info for all the lines
    if(lineId) {
      linesInUnit = await this.lineEnt.find({select: ['lineId', 'lineDesc'], where: { unitId: unit, lineId: lineId }});
    } else {
      linesInUnit = await this.lineEnt.find({select: ['lineId', 'lineDesc'], where: { unitId: unit }});
    }
    for(const lineRec of linesInUnit) {
      // get the total qty for the line
      const lineWiseOutputQuery = await this.lineActualDayTrackEnt.createQueryBuilder('ldat')
      .select(` SUM(good_quantity) as good_quantity, CAST(plan_date as CHAR) as plan_date, COUNT(DISTINCT operator_id) as operators, GROUP_CONCAT(DISTINCT style_id) as styles_string `)
      .where(`unit_id = '${unit}' AND plan_date BETWEEN '${fromDate}' AND '${toDate}' AND is_last_op = true AND is_rework = false AND line_id = '${lineRec.lineId}'  `);
      lineWiseOutputQuery.groupBy('plan_date, line_id')
      .orderBy('plan_date, line_id');
      const lineDayWiseResult: {good_quantity: number, plan_date: string, operators: number, styles_string: string }[] = await lineWiseOutputQuery.getRawMany();

      lineDayWiseResult.forEach(r => {
        if(!dateLineWiseQtys.has(r.plan_date)) {
          dateLineWiseQtys.set(r.plan_date, []);
        }
        const planGmts = planQtys?.get(r.plan_date)?.get(lineRec.lineId) ?? 0;
        const styles = r.styles_string.split(",");
        const styleDesc = stylesMap?.get(styles[0]) ?? 'No Style';

        const lineQtyModel = new LineWiseGarmentsModel(lineRec.lineId, lineRec.lineNumber, Number(planGmts), Number(r.good_quantity), styles[0], styleDesc, 'No buyer', 0, r.operators, 0, null);
        dateLineWiseQtys.get(r.plan_date).push(lineQtyModel);
      });
    }

    const dayLineQtysModels: DayLineWiseCompletedGarmentsModel[] = [];
    dateLineWiseQtys.forEach((lineQtys, date) => {
      dayLineQtysModels.push(new DayLineWiseCompletedGarmentsModel(date, lineQtys));
    });

    return new DayLineWiseCompletedGarmentsResponse(true, 0, 'Day and line wise gmt info retrieved', dayLineQtysModels);
  }



  async getPlanQtyDayWiseForDateRange(fromDate: string, toDate: string, unit: string ): Promise<Map<string, Map<string, number>>> {
    const dateLinePlanQtyMap = new Map<string, Map<string, number>>(); // date => line => plan qty

    const plantQtys: {total_plan_qty: number, line_id: string, plan_date: string }[] = await this.linePlanEnt.createQueryBuilder('lp')
    .select(' SUM(plan_quantity) as total_plan_qty, line_id, CAST(plan_date as CHAR) as plan_date')
    .where(` plan_date BETWEEN '${fromDate}' AND '${toDate}' AND unit_id = '${unit}'  `)
    .groupBy(' plan_date, line_id ')
    .getRawMany();

    plantQtys.forEach(rec => {
      if(!dateLinePlanQtyMap.has(rec.plan_date)) {
        dateLinePlanQtyMap.set(rec.plan_date, new Map<string, number>());
      }
      dateLinePlanQtyMap.get(rec.plan_date).set(rec.line_id, rec.total_plan_qty);
    });
    // date => line => plan qty

    return dateLinePlanQtyMap;
  }













  /**
   * 2
   * gets the style and operation level consumption details for the given date at the unit level. DESC order by consumption time
   * @param req 
   * @returns 
   */
  async getStyleAndOperationLevelTimeConsumptionDetails(req: UnitLineDateRequest): Promise<StyleOperationsTimeConsResponse> {

    const query = this.lineActualDayTrackEnt.createQueryBuilder('ladt')
      .select(' style_id, SUM(actual_spent_time) as time_spent_in_seconds, is_last_op, count(DISTINCT operator_id) as operators, operation_id, line_id ')
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' `);
    if (req.lineId) {
      query.andWhere(` line_id = '${req.lineId}' `);
    }
    query.groupBy('unit_id, plan_date, style_id, operation_id')
      .orderBy('unit_id, plan_date, line_id, style_id')
      .addOrderBy('time_spent_in_seconds', 'DESC');

    const result: { style_id: string, time_spent_in_seconds: number, is_last_op: boolean, operators: number, operation_id: string, line_id: string }[] = await query.getRawMany();

    if (result.length == 0) {
      throw new ErrorResponse(0, 'No style operations summary found');
    }

    const styleOpsTempMap = new Map<string, Set<string>>();
    const styleIds = new Set<string>();
    result.forEach(rec => {
      styleIds.add(rec.style_id);

      // TEMPORARY BLACK OUT
      if (!styleOpsTempMap.has(rec.style_id)) {
        styleOpsTempMap.set(rec.style_id, new Set<string>());
      }
      styleOpsTempMap.get(rec.style_id).add(rec.operation_id);
      // TEMPORARY BLACK OUT
    });

    const opInfo = await this.inaHelperService.getOperationsInfo(req.unit);
    const stylesInfo = await this.inaHelperService.getStyleInfo(req.unit, Array.from(styleIds));
    const styleOpsInfo = await this.getOperationsForStyle(req.unit, Array.from(styleIds));

    const styleLevelConsMap = new Map<string, StyleOperationsTimeConsModel>();
    result.forEach(rec => {
      rec.time_spent_in_seconds = Number(rec.time_spent_in_seconds);

      if (!styleLevelConsMap.has(rec.style_id)) {
        const styleInfo = stylesInfo?.get(rec.line_id)?.get(rec.style_id);
        const styleOps = styleOpsInfo.get(rec.style_id);
        // const ops = styleOps.map(op => op.opId);
        // TEMPORARY BLACK OUT
        const ops = styleOpsTempMap.get(rec.style_id) ? Array.from(styleOpsTempMap.get(rec.style_id)) : [];
        styleLevelConsMap.set(rec.style_id, new StyleOperationsTimeConsModel(rec.style_id, styleInfo?.styleDesc, ops, []));
      }
      const currOpInfo = opInfo?.get(rec.line_id)?.get(rec.operation_id);

      styleLevelConsMap.get(rec.style_id).operationLevelTime.push(
        new OperationTimeConsModel(rec.operation_id, currOpInfo?.operationDesc, rec.time_spent_in_seconds, rec.is_last_op, rec.operators)
      );
    });

    const stylesCons: StyleOperationsTimeConsModel[] = [];
    styleLevelConsMap.forEach(st => {
      stylesCons.push(st);
    });
    return new StyleOperationsTimeConsResponse(true, 0, 'Style and op level time consumption retrieved successfully', stylesCons);
  }






  /**
   * 3 - PENDING - change this completely
   * gets the hour wise line wise and workstation level efficiency
   * for the line and hour level, the efficiency is based on the last operation.
   * for the workstation level, it is based on the operations within the workstation
   * @param req 
   */
  async getHourlyLineWorkstationEfficiency(req: UnitLineDateRequest): Promise<LineWorkstationEfficiencyResponse> {
    // line eff
    // const query = await this.effEnt.createQueryBuilder('eff')
    // .select(` hour, line_id, SUM(actual_plan_time) as total_plan_secs, SUM(actual_spent_time) as total_spent_secs, count(1) as total_records `)
    // .where(` unit = '${req.unit}' AND plan_date = '${req.date}' AND is_last_op = true `)
    // .groupBy(` unit, plan_date, line_id`);
    // if(req.isGroupByHour) {
    //   query.addGroupBy('hour');
    // }
    // query.orderBy('unit, plan_date, line_id');

    const lineStyleGmtSmvRes = await this.getLineStyleGarmentAndOperationsSmv(req); // line => styleid => gmt smv
    const lineStyleGmtSmvMap = new Map<string, Map<string, number>>();
    const lineWiseOutputEffMap = new Map<string, number>();
    lineStyleGmtSmvRes.data.forEach(l => {
      lineStyleGmtSmvMap.set(l.lineId, new Map<string, number>());
      l.stylesSmv.forEach(s => {
        lineStyleGmtSmvMap.get(l.lineId).set(s.style, s.garmentSmv);
      });
    });
    // console.log(lineStyleGmtSmvMap);
    const todayOutputResult: {style_id: string, total_output: number, operators: string, line_id: string}[]  = await this.lineActualDayTrackEnt.createQueryBuilder('ladt')
    .select(` style_id, SUM( if(is_last_op = true, good_quantity, 0) ) as total_output, GROUP_CONCAT(DISTINCT operator_id) as operators, line_id `)
    .where(`  unit_id = '${req.unit}' AND plan_date = '${req.date}'  `)
    .groupBy(`line_id, style_id`)
    .orderBy(`line_id`)
    .getRawMany();
    // console.log(todayOutputResult);
    const lineLevelOutputAndSmv = new Map<string, {outputSmvMins: number, totalOutput: number, totalOperators: Set<string>}>();
    todayOutputResult.forEach(r => {
      if(!lineLevelOutputAndSmv.has(r.line_id)) {
        lineLevelOutputAndSmv.set(r.line_id, { outputSmvMins: 0, totalOperators: new Set<string>, totalOutput: 0});
      }
      const operatorsArray =  r.operators.split(',');
      operatorsArray?.forEach(o => lineLevelOutputAndSmv.get(r.line_id).totalOperators.add(o));

      let gmtSmv = lineStyleGmtSmvMap?.get(r.line_id)?.get(r.style_id) ?? 0;
      let gmtSmvInMins = Number((gmtSmv/60).toFixed(2));
      let output = Number(r.total_output);

      lineLevelOutputAndSmv.get(r.line_id).outputSmvMins += (output * gmtSmvInMins);
      lineLevelOutputAndSmv.get(r.line_id).totalOutput += output;
    });

    const hour = new Date().getHours();
    const unitWorkedMinutesTillNow = await this.getUnitWorkedMinutesTillNow(req.unit, req.date, hour);
    const converedLines = new Set<string>();
    if(todayOutputResult.length > 0) {
      // now calculate the line wise output efficiencies
      /** LINE EFF is calculated as  [(total output*total GMT SMV)/(operators*working hours*60)] * 100  */
      todayOutputResult.forEach((r, ind) => {
        const lineSmvMinsAndOprts = lineLevelOutputAndSmv.get(r.line_id);
        const eff =  unitWorkedMinutesTillNow > 0 ? ((lineSmvMinsAndOprts.outputSmvMins) / (lineSmvMinsAndOprts.totalOperators.size * unitWorkedMinutesTillNow) ) * 100 : 0; // 8 hours * 60 mins
        if(lineWiseOutputEffMap.has(r.line_id)) {
          const preEff = lineWiseOutputEffMap.get(r.line_id);
          const newEff = (preEff + eff)/2; // expecting atmost only 2 styles will be present at any given time
          lineWiseOutputEffMap.set(r.line_id, Number(newEff.toFixed(2)));
        } else {
          lineWiseOutputEffMap.set(r.line_id, Number(eff.toFixed(2)));
        }
      });
    }
    // console.log(lineWiseOutputEffMap);


    // the divider is the total planned secs. If grouped by hour, the we have to get the planned minutes within the hour else for the whole day
    // const unitWorkingMinutesPerHourMap = await this.migHelperService.getUntiPlannedWorkingMinutesPerHoursForDay(req.unit, req.date);
    // let divider = req.isGroupByHour ? 60 * 60 : 60*60*this.shiftWorkingTime;
    const query = await this.linePlanEnt.createQueryBuilder('ldp')
      .select(' ldp.hour, ldp.line_id, ldp.plan_quantity as planned_quantity, garment_smv, SUM(efficiency) as avg_efficiency, COUNT(DISTINCT line_eff.hour) as hours_count')
      .leftJoin(LineEfficiencyDayTrackEntity, 'line_eff', 'ldp.unit_id = line_eff.unit_id AND ldp.line_id = line_eff.line_id AND line_eff.hour = ldp.hour AND ldp.plan_date = line_eff.plan_date ')
      .where(` ldp.unit_id = '${req.unit}' AND ldp.plan_date = '${req.date}' `)
      .groupBy(' ldp.unit_id, ldp.plan_date, ldp.line_id ');
    if (req.isGroupByHour) {
      query.addGroupBy('ldp.hour');
    }
    query.orderBy('ldp.unit_id, ldp.plan_date, ldp.line_id, ldp.hour');

    const result: { hour: number, line_id: string,  planned_quantity: number, garment_smv: number, avg_efficiency: number, hours_count: number }[] = await query.getRawMany();
    if (result.length == 0) {
      throw new ErrorResponse(0, 'No efficiency summary found');
    }

    const lineIds = new Set<string>();
    result.forEach(rec => {
      lineIds.add(rec.line_id);
    });
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit, Array.from(lineIds));
    const workstationsInfo = await this.inaHelperService.getWorkstationInfo(req.unit);

    // workstation level eff
    // const query2 = await this.linePlanEnt.createQueryBuilder('ldp')
    //   .select(` ldp.hour, ldp.line_id, workstation_id, SUM(actual_plan_time) as total_plan_secs, SUM(actual_spent_time) as total_spent_secs, count(1) as total_records, SUM(actual_plan_time) as total_hour_plan_secs`)
    //   .leftJoin(OperatorEfficiencyDayTrackEntity, 'op_eff', 'ldp.unit_id = op_eff.unit_id AND ldp.line_id = op_eff.line_id AND op_eff.hour = ldp.hour AND ldp.plan_date = op_eff.plan_date ')
    //   .where(` ldp.unit_id = '${req.unit}' AND ldp.plan_date = '${req.date}' `)
    //   .groupBy(` ldp.unit_id, ldp.plan_date, ldp.line_id, op_eff.workstation_id`);
    // if (req.isGroupByHour) {
    //   query2.addGroupBy('ldp.hour');
    // }
    const query2 = await this.linePlanEnt.createQueryBuilder('ldp')
      .select(` ldp.hour, ldp.line_id, workstation_id, SUM(efficiency) as avg_efficiency, SUM(actual_plan_time) as total_plan_secs, SUM(actual_spent_time) as total_spent_secs, SUM(actual_plan_time) as total_hour_plan_secs`)
      .leftJoin(OperatorEfficiencyDayTrackEntity, 'op_eff', 'ldp.unit_id = op_eff.unit_id AND ldp.line_id = op_eff.line_id AND op_eff.hour = ldp.hour AND ldp.plan_date = op_eff.plan_date ')
      .where(` ldp.unit_id = '${req.unit}' AND ldp.plan_date = '${req.date}' `)
      .groupBy(` ldp.unit_id, ldp.plan_date, ldp.line_id, op_eff.workstation_id`);
    if (req.isGroupByHour) {
      query2.addGroupBy('ldp.hour');
    }
    query2.orderBy('ldp.unit_id, ldp.plan_date, ldp.line_id, ldp.hour, workstation_id');
    const result2: { hour: number, line_id: string, workstation_id: string, avg_efficiency, total_hour_plan_secs: number, total_plan_secs: number, total_spent_secs: number }[] = await query2.getRawMany();

    // maintain the workstation level eff map
    const workstationEffMap = new Map<number, Map<string, WorkstationEfficiencyModel[]>>();
    result2.forEach(rec => {
      let hour = req.isGroupByHour ? rec.hour : 1;

      rec.total_plan_secs = Number(rec.total_plan_secs);
      rec.total_spent_secs = Number(rec.total_spent_secs);
      rec.total_hour_plan_secs = Number(rec.total_hour_plan_secs);

      const workstationInfo = workstationsInfo?.get(rec.line_id)?.get(rec.workstation_id);
      if (!workstationEffMap.has(hour)) {
        workstationEffMap.set(hour, new Map<string, WorkstationEfficiencyModel[]>());
      }

      if (!workstationEffMap?.get(hour)?.has(rec.line_id)) {
        workstationEffMap?.get(hour)?.set(rec.line_id, []);
      }

      // let workstationEff = rec.total_spent_secs > 0 ? Math.round(100 * rec.total_plan_secs / divider ) : 0;
      let workstationEff = Number(rec.avg_efficiency);
      workstationEffMap?.get(hour)?.get(rec.line_id)?.push(
        new WorkstationEfficiencyModel(rec.workstation_id, workstationInfo?.workstationDesc, workstationEff, rec.total_hour_plan_secs, rec.total_plan_secs, rec.total_spent_secs, 0, hour)
      );
    });

    // const lineEffMap = new Map<number, Map<string, LineEfficiencyModel>>();
    let totalEff = 0;
    const lineEffMap = new Map<number, HourWiseEfficiencyModel>();
    for (const rec of result) {
      rec.garment_smv = Number(rec.garment_smv);
      rec.avg_efficiency = Number(rec.avg_efficiency);

      let hour = req.isGroupByHour ? rec.hour : 1;
      if (!lineEffMap.has(rec.hour)) {
        lineEffMap.set(rec.hour, new HourWiseEfficiencyModel(hour, 0, []));
      }

      const lineInfo = linesInfo.get(rec.line_id);
      // TODO: remove the /9 and put the rec.hours_count
      // COMMENTED BELOW STATEMENT ON 2024-03-07
      // const lineEff = Math.round(rec.avg_efficiency);
      const lineEff = lineWiseOutputEffMap.get(rec.line_id);
      /** LINE EFF is calculated as  [(total output*total GMT SMV)/(operators*working hours*60)] * 100  */

      // const lineEff = Math.round(100 * (rec.actual_quantity * rec.garment_smv) / rec.total_spent_secs);
      // const lineEff = Math.round(100 * rec.total_plan_secs/rec.total_spent_secs);

      const workstationEffs = workstationEffMap.get(hour)?.get(rec.line_id);
      lineEffMap.get(rec.hour).lineWiseEfficiency.push(new LineEfficiencyModel(rec.line_id, lineInfo.lineDesc, lineEff, workstationEffs, hour));

    }

    let totalUnitEff = 0;
    let totalHours = 0;

    const hourWiseLineEffRes: HourWiseEfficiencyModel[] = [];
    // loop all the hour wise lines and set the total efficiency for the hour across all the lines
    lineEffMap.forEach((rec, hour) => {

      let totalLineEff = 0;
      rec.lineWiseEfficiency.forEach(r => totalLineEff += r.efficiency);
      const totalLines = rec.lineWiseEfficiency.length;
      rec.efficiency = Math.round(totalLineEff / totalLines);

      totalUnitEff += rec.efficiency;
      totalHours += 1;

      hourWiseLineEffRes.push(rec);
    });

    const unitEff = Math.round(totalUnitEff / totalHours);
    const unitLevelEffRes = new LineWorkStationEfficiencyModel(unitEff, hourWiseLineEffRes);

    return new LineWorkstationEfficiencyResponse(true, 0, 'Workstation efficiencies retrieved successfully', unitLevelEffRes);
  }


  async getUnitWorkedMinutesTillNow(unitId: string, currDate: string, incomingHour?: number): Promise<number> {
    let workedMinutes = 0;
    const unitRec = await this.unitEnt.findOne({ where: { unitId: unitId }});
    const unitHourBreaks = await this.migHelperService.getUnitBreakTimesForDay(unitId, currDate);
    console.log(unitHourBreaks);
    console.log(incomingHour);
    console.log('----------------');
    const workingHours = unitRec.workingHours.split(',');
    console.log(workingHours);
    workingHours.forEach(h => {
      if(Number(h) < incomingHour) {
        workedMinutes += 60;
        const breakMinutes = unitHourBreaks.get(Number(h));
        if (breakMinutes) {
          workedMinutes -= breakMinutes;
        }
      }
    });
    return workedMinutes;
  }





  /**
   * 4
   * gets rework information for the hour wise, line wise and workstation level
   * @param req 
   * @returns 
   */
  async getHourlyLineWorkstationRework(req: UnitLineDateRequest): Promise<LineWorkStationReworkResponse> {
    // rework for line -> workstation
    const query = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(` hour, line_id, SUM(actual_spent_time) as total_spent_secs, SUM(good_quantity) as rework_quantity, count(1) as total_records, workstation_id, operation_id, operator_id `)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' AND is_rework = 1`)
      .groupBy(` unit_id, plan_date, line_id, workstation_id, operation_id`);
    if (req.isGroupByHour) {
      query.addGroupBy('hour');
    }
    query.orderBy('unit_id, plan_date, line_id');
    query.addOrderBy('rework_quantity', 'DESC');

    const result: { hour: number, line_id: string, total_spent_secs: number, total_records: number, rework_quantity: number, workstation_id: string, operation_id: string, operator_id: string }[] = await query.getRawMany();

    const lineIds = new Set<string>();
    const workstationIds = new Set<string>();
    const operatorIds = new Set<string>();
    result.forEach(rec => {
      lineIds.add(rec.line_id);
      workstationIds.add(rec.workstation_id);
      operatorIds.add(rec.operator_id);
    });

    const linesInfo = await this.inaHelperService.getLineInfo(req.unit, Array.from(lineIds));
    const opsInfo = await this.inaHelperService.getOperationsInfo(req.unit);
    const workstationsInfo = await this.inaHelperService.getWorkstationInfo(req.unit);
    const operatorInfo: Map<string, Map<string, OperatorEntity>> = await this.inaHelperService.getOperatorsInfo(req.unit, Array.from(operatorIds));

    const lineWorkstationReworkMap = new Map<string, Map<number, Map<string, OperationReworkModel[]>>>(); // line -> hour -> workstation -> op rework info
    // const lineWorkstationReworkMap = new Map<string, WorkstationReworkModel>();
    // const lineHourWorkstationReworkMap = new Map<string, LineWorkStationReworkModel>();

    result.forEach(rec => {
      const hour = req.isGroupByHour ? rec.hour : 1;

      rec.rework_quantity = Number(rec.rework_quantity);
      rec.total_spent_secs = Number(rec.total_spent_secs);

      if (!lineWorkstationReworkMap.has(rec.line_id)) {
        lineWorkstationReworkMap.set(rec.line_id, new Map<number, Map<string, OperationReworkModel[]>>());
      }
      if (!lineWorkstationReworkMap.get(rec.line_id).has(hour)) {
        lineWorkstationReworkMap.get(rec.line_id).set(hour, new Map<string, OperationReworkModel[]>());
      }
      if (!lineWorkstationReworkMap.get(rec.line_id).get(hour).has(rec.workstation_id)) {
        lineWorkstationReworkMap.get(rec.line_id).get(hour).set(rec.workstation_id, []);
      }
      const opInfo = opsInfo?.get(rec.line_id)?.get(rec.operation_id);
      const operatorDetail = operatorInfo?.get(rec.line_id)?.get(rec.operator_id);
      const operatorName = operatorDetail ? operatorDetail?.operatorName : '';

      lineWorkstationReworkMap.get(rec.line_id)?.get(hour)?.get(rec.workstation_id)?.push(
        new OperationReworkModel(rec.operation_id, opInfo?.operationDesc, rec.rework_quantity, rec.total_spent_secs, hour, operatorName, null, 0)
      );
    });

    // based on the map, construct the response
    const lineReworkModels: LineWorkStationReworkModel[] = [];
    lineWorkstationReworkMap.forEach((hourReworks, lineId) => {
      let totalLineRework = 0;

      const hourReworkModels: HourWiseReworkModel[] = [];
      hourReworks.forEach((workstationRework, hour) => {
        let totalHourRework = 0;

        const workstationReworkModels: WorkstationReworkModel[] = [];
        workstationRework.forEach((opsRework, workstationId) => {
          let totalWorkstationRework = 0;
          opsRework.forEach(opRework => {
            totalWorkstationRework += opRework.totalRework;
          });
          const workstationInfo = workstationsInfo?.get(lineId)?.get(workstationId);
          const workstationReworkModel = new WorkstationReworkModel(workstationId, workstationInfo?.workstationDesc, totalWorkstationRework, opsRework);
          workstationReworkModels.push(workstationReworkModel);

          totalHourRework += totalWorkstationRework;
        });
        const hourReworkModel = new HourWiseReworkModel(totalHourRework, hour, workstationReworkModels);
        hourReworkModels.push(hourReworkModel);

        totalLineRework += totalHourRework;
      });
      const lineInfo = linesInfo.get(lineId);
      const lineReworkModel = new LineWorkStationReworkModel(lineId, lineInfo?.lineDesc, totalLineRework, hourReworkModels);
      lineReworkModels.push(lineReworkModel);
    });
    return new LineWorkStationReworkResponse(true, 0, 'Hourly line and workstation level rework retrieved successfully', lineReworkModels);
  }






  /**
   * 5 PENDING - NOT REQUIRED BASED ON NEW CHANGES
   * gets the line wise and operation wise completed garments info
   * @param req 
   */
  async getLineOperationCompletedGarment(req: UnitLineDateRequest): Promise<OperationCompletionResponse> {
    const query = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(`line_id, style_id, SUM(actual_spent_time) as total_spent_secs, SUM(good_quantity) as actual_quantity, operation_id `)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' AND is_rework = false`)
      .groupBy(` unit_id, plan_date, line_id, style_id, operation_id`);
    if (req.isGroupByHour) {
      // query.addGroupBy('hour');
    }
    query.orderBy('unit_id, plan_date, line_id, operation_id');

    const result: { line_id: string, style_id: string, total_plan_secs: number, actual_quantity: number, operation_id: string }[] = await query.getRawMany();

    const styleOpsMap = new Map<string, Set<string>>();
    const stylesSet = new Set<string>();
    const lineIds = new Set<string>();
    result.forEach(rec => {
      lineIds.add(rec.line_id);
      if (!styleOpsMap.has(rec.style_id)) {
        styleOpsMap.set(rec.style_id, new Set<string>());
      }
      styleOpsMap.get(rec.style_id).add(rec.operation_id);
      stylesSet.add(rec.style_id);
    });

    const styleOps = await this.getOperationsForStyle(req.unit, Array.from(stylesSet));
    const opsOrderMap = new Map<string, { opId: string, opDesc: string, opOrder: number }>();
    styleOps.forEach(recs => {
      // this will be already iterating in an order
      recs.forEach(op => {
        // the final operations in the specific order
        // TODO
        // opsOrderMap.set(op.opId, {opId: op.opId, opDesc: op.opCode, opOrder: op.opOrder});
      });
    });

    // based on the all style ops, construct the order of the operations
    const finalSortedOperations: string[] = Array.from(opsOrderMap.keys());
    const totalOpsCount = finalSortedOperations.length;
    const breakDownOps: string[] = []; // 30% , 60% , 90 or 100% based on no of operations - always the array size is 3
    if (totalOpsCount > 0) {
      const breakAt = Math.floor(totalOpsCount / 3);
      if (totalOpsCount == 1) {
        breakDownOps.push(finalSortedOperations[0], finalSortedOperations[0], finalSortedOperations[0]);
      } else if (totalOpsCount == 2) {
        breakDownOps.push(finalSortedOperations[0], finalSortedOperations[0], finalSortedOperations[1]);
      } else if (totalOpsCount == 3) {
        breakDownOps.push(finalSortedOperations[0], finalSortedOperations[1], finalSortedOperations[2]);
      } else {
        breakDownOps.push(finalSortedOperations[breakAt - 1], finalSortedOperations[2 * breakAt - 1], finalSortedOperations[3 * breakAt - 1]);
      }
    }
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit, Array.from(lineIds));
    const opsInfo = await this.inaHelperService.getOperationsInfo(req.unit);

    const lineGmtCompletionMap = new Map<string, Map<string, OperationCompletionModel>>();
    result.forEach(rec => {
      rec.actual_quantity = Number(rec.actual_quantity);
      if (!lineGmtCompletionMap.has(rec.line_id)) {
        lineGmtCompletionMap.set(rec.line_id, new Map<string, OperationCompletionModel>);
      }
      if (!lineGmtCompletionMap.get(rec.line_id).has(rec.operation_id)) {
        const opInfo = opsInfo?.get(rec.line_id)?.get(rec.operation_id);
        lineGmtCompletionMap.get(rec.line_id).set(rec.operation_id, new OperationCompletionModel(rec.operation_id, opInfo?.operationDesc, 0));
      }
      // adding the completed gmt qty per operation.
      lineGmtCompletionMap.get(rec.line_id).get(rec.operation_id).garmentsCompletedForOperation += rec.actual_quantity;
    });


    const lineOpCompletedModels: LineOperationCompletionModel[] = [];
    lineGmtCompletionMap.forEach((opsGmts, lineId) => {
      const opGmtCompletedModels: OperationCompletionModel[] = [];

      // push the operations in the op order
      opsOrderMap.forEach((opInfo, sortedOp) => {
        opsGmts.forEach((opGmt, opId) => {
          if (opId == sortedOp) {
            opGmtCompletedModels.push(opGmt);
          }
        });
      });

      const lineInfo = linesInfo.get(lineId);
      const lineOpCompletedModel = new LineOperationCompletionModel(lineId, lineInfo?.lineDesc, breakDownOps, finalSortedOperations, opGmtCompletedModels);
      lineOpCompletedModels.push(lineOpCompletedModel);
    });

    return new OperationCompletionResponse(true, 0, 'Operation completion response retrieved successfully', lineOpCompletedModels);
  }











  /**
   * 6
   * gets the line + operator + operation level rework
   * gets the line + operator + operation level efficiency
   * @param req 
   */
  async getLineOperatorOperationEfficiency(req: UnitLineDateRequest): Promise<OperatorReworkResponse> {
    // get the operator level rework quantities
    const reworkQuery = this.lineActualDayTrackEnt.createQueryBuilder('ladt')
      .select(' hour, line_id, operation_id, operator_id, SUM(if(is_rework = true, good_quantity, 0)) as total_rework_quantity, SUM(if(is_rework = false, good_quantity, 0)) as total_completed_quantity, is_last_op, is_rework')
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' `)
      .groupBy('unit_id, plan_date, line_id, operation_id, operator_id')
    if (req.isGroupByHour) {
      // query.addGroupBy('hour');
    }
    reworkQuery.orderBy('unit_id, plan_date, hour, line_id')
    reworkQuery.addOrderBy('total_rework_quantity', 'DESC');


    const reworkResult: { hour: number, line_id: string, operation_id: string, operator_id: string, total_rework_quantity: number, total_completed_quantity: number, is_last_op: boolean, is_rework: boolean }[] = await reworkQuery.getRawMany();

    if (reworkResult.length == 0) {
      throw new ErrorResponse(0, 'No Operator efficiency info found');
    }

    const lineIds = new Set<string>();
    const operatorIds = new Set<string>();
    reworkResult.forEach(rec => {
      lineIds.add(rec.line_id);
      operatorIds.add(rec.operator_id);
    });
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit, Array.from(lineIds));
    const operatorsInfo = await this.inaHelperService.getOperatorsInfo(req.unit, Array.from(operatorIds));
    const opsInfo = await this.inaHelperService.getOperationsInfo(req.unit);

    const lineLevelOpMap = new Map<string, OperatorReworkModel[]>();
    reworkResult.forEach(rec => {
      rec.total_rework_quantity = Number(rec.total_rework_quantity);
      rec.total_completed_quantity = Number(rec.total_completed_quantity);

      if (!lineLevelOpMap.has(rec.line_id)) {
        lineLevelOpMap.set(rec.line_id, []);
      }
      const operatorInfo = operatorsInfo?.get(rec.line_id)?.get(rec.operator_id);
      const opInfo = opsInfo?.get(rec.line_id)?.get(rec.operation_id);
      lineLevelOpMap.get(rec.line_id).push(
        new OperatorReworkModel(rec.operator_id, operatorInfo?.operatorName, rec.operation_id, opInfo?.operationDesc, rec.total_completed_quantity, rec.total_rework_quantity, rec.is_last_op, 0)
      );
    });

    // get the line + operation + operator wise efficiency
    // get the operator efficiency
    const effQuery = await this.operatorEffEnt.createQueryBuilder('line_eff')
      .select(` hour, line_id, operation_id, operator_id, SUM(actual_plan_time) as total_plan_secs, SUM(actual_spent_time) as total_spent_secs, efficiency, is_last_op`)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' `)
      .groupBy(` unit_id, plan_date, line_id, operation_id, operator_id`);
    if (req.isGroupByHour) {
      // query.addGroupBy('hour');
    }
    effQuery.orderBy('unit_id, plan_date, line_id');
    effQuery.addOrderBy('efficiency', 'DESC');

    const effResult: { hour: number, line_id: string, operation_id: string, operator_id: string, total_plan_secs: number, total_spent_secs: number, efficiency: number, is_last_op: boolean }[] = await effQuery.getRawMany();
    if (effResult.length == 0) {
      throw new ErrorResponse(0, 'No Operator efficiency info found');
    }
    const operatorEffMap = new Map<string, number>();
    effResult.forEach(rec => {
      rec.efficiency = Number(rec.efficiency);
      const key = rec.line_id + '@' + rec.operation_id + '@' + rec.operator_id;
      operatorEffMap.set(key, rec.efficiency);
    });

    const lineOperationOperatorEffModels: LineOperatorsReworkModel[] = [];
    lineLevelOpMap.forEach((opEffs, lineId) => {
      opEffs.forEach(effRec => {
        const key = lineId + '@' + effRec.operationId + '@' + effRec.operatorId;
        effRec.eff = operatorEffMap.get(key);
      })
      const lineInfo = linesInfo.get(lineId);
      lineOperationOperatorEffModels.push(new LineOperatorsReworkModel(lineId, lineInfo?.lineDesc, opEffs));
    });
    const linesReworkModel = new LinesReworkModel(lineOperationOperatorEffModels);
    return new OperatorReworkResponse(true, 0, 'Operator level rework and efficiency retrieved', linesReworkModel);
  }





  /**
   * 10
   * Need to break this based ont he lunch break
   * @param req 
   * @returns 
   */
  async getLineOperationsEfficiency(req: UnitLineDateRequest): Promise<LineOperationEfficiencyResponse> {
    const effCalcQuery = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(`line_id, hour, operation_id, SUM(good_quantity) AS completed_qty, operation_smv, SUM(actual_spent_time) as actual_spent_time, COUNT(DISTINCT workstation_id) AS total_workstations `)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}'`)
      .groupBy(`unit_id, line_id, operation_id, hour`);
    effCalcQuery.orderBy('unit_id, line_id');
    const effCalcResult: { line_id: string, hour: number, operation_id: string, completed_qty: number, actual_spent_time: number, total_workstations: number, operation_smv: number }[] = await effCalcQuery.getRawMany();

    const effMap = new Map<string, Map<string, { totalCompGmt: number, avgCompGmt: number, opSmv: number, manTime: number, avgTotalSpentTime: number, totalSpentTime: number }>>();

    const unitWorkingMinutesPerHourMap = await this.migHelperService.getUntiPlannedWorkingMinutesPerHoursForDay(req.unit, req.date);

    effCalcResult.forEach(rec => {
      rec.completed_qty = Number(rec.completed_qty);
      rec.actual_spent_time = Number(rec.actual_spent_time);

      if (!effMap.has(rec.line_id)) {
        effMap.set(rec.line_id, new Map<string, { totalCompGmt: number, avgCompGmt: number, opSmv: number, manTime: number, avgTotalSpentTime: number, totalSpentTime: number }>());
      }
      if (!effMap.get(rec.line_id).has(rec.operation_id)) {
        effMap.get(rec.line_id).set(rec.operation_id, { totalCompGmt: 0, avgCompGmt: 0, opSmv: 0, manTime: 0, avgTotalSpentTime: 0, totalSpentTime: 0 });
      }
      const opInfo = effMap.get(rec.line_id).get(rec.operation_id);

      const totalWorkstations = rec.total_workstations;
      const currHourWorkingMinutes = unitWorkingMinutesPerHourMap.get(rec.hour) ?? 60; // if the current wokring hour minutes are 0, then consider it as 60 (full hour) to avoid division by 0 problem
      opInfo.manTime += totalWorkstations * 60 * currHourWorkingMinutes // 60seconds * curr hour planned working minutes
      opInfo.opSmv = rec.operation_smv;
      opInfo.totalSpentTime += rec.actual_spent_time;
      opInfo.avgTotalSpentTime += Math.round(rec.actual_spent_time / totalWorkstations);
      opInfo.avgCompGmt += Math.round(rec.completed_qty / totalWorkstations);
      opInfo.totalCompGmt += rec.completed_qty;
    });

    const opsInfo = await this.inaHelperService.getOperationsInfo(req.unit);
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit);

    const query = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(`line_id, operation_id, SUM(good_quantity) AS completed_qty, operation_smv, SUM(actual_spent_time) as actual_spent_time, COUNT(1) AS total_workstations `)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}'`)
      .groupBy(`unit_id, line_id, operation_id`);
    query.orderBy('unit_id, line_id');
    const result: { line_id: string, hour: number, operation_id: string, completed_qty: number, actual_spent_time: number, total_workstations: number, operation_smv: number }[] = await query.getRawMany();


    const opEffMap = new Map<string, Map<string, OperationEfficiencyModel>>();
    for (const rec of result) {
      if (!opEffMap.has(rec.line_id)) {
        opEffMap.set(rec.line_id, new Map<string, OperationEfficiencyModel>());
      }

      const effInfo = effMap?.get(rec.line_id)?.get(rec.operation_id);
      const eff = Math.round(((effInfo.totalCompGmt * effInfo.opSmv) / effInfo.manTime) * 100);

      const opInfo = opsInfo?.get(rec.line_id)?.get(rec.operation_id);

      opEffMap.get(rec.line_id).set(rec.operation_id, new OperationEfficiencyModel(rec.operation_id, opInfo?.operationDesc, effInfo.totalCompGmt, eff, effInfo.totalSpentTime, rec.operation_smv));
    }

    const lineOpEffModels: LineOperationEfficiencyModel[] = [];
    opEffMap.forEach((opInfo, l) => {
      const opEffModels: OperationEfficiencyModel[] = [];
      opInfo.forEach((eff, op) => {
        opEffModels.push(eff);
      });

      // sort based on the eff desc;
      opEffModels.sort((a, b) => a.efficiency - b.efficiency);
      const lineInfo = linesInfo.get(l);
      lineOpEffModels.push(new LineOperationEfficiencyModel(l, lineInfo?.lineDesc, opEffModels));
    });
    return new LineOperationEfficiencyResponse(true, 0, 'Line operation level efficiencies retrieved successfully', lineOpEffModels);
  }

  /**
   * 8
   * Gets the line level downtimes
   * @param req 
   * @returns 
   */
  async getLineWiseDownTimes(req: UnitLineDateRequest): Promise<LineDowntimeResponse> {
    const query = this.downTimeEntity.createQueryBuilder('d')
      .select(`hour, line_id, operator_id, operation_id, workstation_id, downtime_reason, downtime_code, operation_smv, SUM(downtime) AS total_downtime`)
      .where(`unit_id = '${req.unit}' AND plan_date = '${req.date}' AND downtime > 0`)
      .groupBy('line_id, downtime_reason, workstation_id');
    if (req.isGroupByHour) {
      query.addGroupBy('hour');
    }
    query.orderBy('line_id, hour');
    const result: { hour: number, line_id: string, operator_id: string, operation_id: string, workstation_id: string, downtime_reason: string, downtime_code: string, operation_smv: number, total_downtime: number }[] = await query.getRawMany();
    if (result.length == 0) {
      throw new ErrorResponse(0, 'Downtime is not found for the date : ' + req.date)
    }

    const workstationsInfo = await this.inaHelperService.getWorkstationInfo(req.unit);
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit);
    const reasonsInfo = await this.inaHelperService.getReasons(req.unit);

    const hourLineDowntimeMap = new Map<number, Map<string, Map<string, WorkstationDowntimeModel[]>>>();
    for (const rec of result) {
      const hour = req.isGroupByHour ? rec.hour : 1;

      rec.total_downtime = Number(rec.total_downtime);
      if (!hourLineDowntimeMap.has(hour)) {
        hourLineDowntimeMap.set(hour, new Map<string, Map<string, WorkstationDowntimeModel[]>>());
      }
      if (!hourLineDowntimeMap.get(hour).has(rec.line_id)) {
        hourLineDowntimeMap.get(hour).set(rec.line_id, new Map<string, WorkstationDowntimeModel[]>());
      }
      if (!hourLineDowntimeMap.get(hour).get(rec.line_id).has(rec.downtime_code)) {
        hourLineDowntimeMap.get(hour).get(rec.line_id).set(rec.downtime_code, []);
      }

      const workstationInfo = workstationsInfo?.get(rec.line_id)?.get(rec.workstation_id);
      hourLineDowntimeMap.get(hour).get(rec.line_id).get(rec.downtime_code).push(
        new WorkstationDowntimeModel(rec.workstation_id, workstationInfo?.workstationDesc, rec.total_downtime, rec.operation_smv, rec.downtime_reason)
      );
    }

    const hourDownTimeModels: HourWiseDowntimeModel[] = []
    hourLineDowntimeMap.forEach((lineWorkstations, h) => {

      const lineWiseDownModels: LineDowntimeModel[] = [];
      lineWorkstations.forEach((reasonDowntimes, l) => {

        const reasonDowntimeModels: ReasonWiseDowntimeModel[] = [];
        reasonDowntimes.forEach((workstations, reason) => {

          const reasonInfo = reasonsInfo?.get(l)?.get(reason);
          reasonDowntimeModels.push(new ReasonWiseDowntimeModel(reason, reasonInfo?.level, workstations));
        });

        const lineInfo = linesInfo.get(l);
        lineWiseDownModels.push(new LineDowntimeModel(l, lineInfo?.lineDesc, reasonDowntimeModels));
      });

      hourDownTimeModels.push(new HourWiseDowntimeModel(h, lineWiseDownModels));
    });

    return new LineDowntimeResponse(true, 0, 'Line downtimes retrieved successfully', hourDownTimeModels);
  }


  /**
   * 9
   * Get the opportunity operations
   * @param req 
   * @returns 
   */
  async getOpportunityOperations(req: UnitLineDateRequest): Promise<LineOpportunityOperationsResponse> {
    const hourWiseOpQuery = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(`line_id, hour, operation_id, SUM(good_quantity) AS completed_qty, operation_smv, operator_id, SUM(actual_spent_time) as actual_spent_time, workstation_id`)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' AND is_rework = false`)
      .groupBy(`unit_id, line_id, hour, operation_id, workstation_id`)
      .orderBy('unit_id, line_id, hour');

  
    const hourWiseOpResult: { line_id: string, hour: number, operation_id: string, completed_qty: number, actual_spent_time: number, operation_smv: number, workstation_id: string, operator_id: string }[] = await hourWiseOpQuery.getRawMany();

    if (hourWiseOpResult.length == 0) {
      throw new ErrorResponse(0, 'Opportunity operations data not found');
    }

    const operatorIds = new Set<string>();
    const perGmtTimeMap = new Map<string, { hour: number, gmtTime: number }[]>();
    hourWiseOpResult.forEach(rec => {
      rec.completed_qty = Number(rec.completed_qty);
      rec.actual_spent_time = Number(rec.actual_spent_time);
      const key = rec.line_id + '@' + rec.operation_id + '@' + rec.workstation_id;
      if (!perGmtTimeMap.has(key)) {
        perGmtTimeMap.set(key, []);
      }
      // TODO: For temporary testing, the formula as Math.round(rec.completed_qty / (rec.actual_spent_time / 60 ));
      const gmtTimeCalc = Math.round((rec.actual_spent_time) / rec.completed_qty );
      perGmtTimeMap.get(key).push({ hour: rec.hour, gmtTime: gmtTimeCalc > 0 ? gmtTimeCalc :  0 });

      operatorIds.add(rec.operator_id);
    });

    // check and add the unit hours if there is no transaction for the hour + line + workstation
    perGmtTimeMap.forEach((hourObjs, key) => {
      this.unitShiftHours.forEach(hr => {
        const hrExist = hourObjs.find(v => v.hour == hr);
        if (!hrExist) {
          hourObjs.push({ hour: hr, gmtTime: 0 });
        }
      });
      hourObjs.sort((a, b) => a.hour - b.hour);
    });

    const operators: string[] = operatorIds ? Array.from(operatorIds) : [];
    const opWorkstationQuery = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(`line_id, operation_id, SUM(good_quantity) AS completed_qty, operation_smv, operator_id, SUM(actual_spent_time) as actual_spent_time, workstation_id`)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' AND is_rework = false`)
      .groupBy(`unit_id, line_id, operation_id, workstation_id`)
      .orderBy('unit_id, line_id');
    const opWorkstationResult: { line_id: string, hour: number, operation_id: string, completed_qty: number, actual_spent_time: number, operation_smv: number, workstation_id: string, operator_id: string }[] = await opWorkstationQuery.getRawMany();

    const opsInfo = await this.inaHelperService.getOperationsInfo(req.unit);
    const workstationInfo = await this.inaHelperService.getWorkstationInfo(req.unit);
    const operatorsInfo = await this.inaHelperService.getOperatorsInfo(req.unit, operators);
    const linesInfo = await this.inaHelperService.getLineInfo(req.unit);

    const lineOpWorkstationMap = new Map<string, Map<string, OpportunityOperationWorkstationModel[]>>();

    opWorkstationResult.forEach(rec => {
      if (!lineOpWorkstationMap.has(rec.line_id)) {
        lineOpWorkstationMap.set(rec.line_id, new Map<string, OpportunityOperationWorkstationModel[]>());
      }
      if (!lineOpWorkstationMap.get(rec.line_id).has(rec.operation_id)) {
        lineOpWorkstationMap.get(rec.line_id).set(rec.operation_id, []);
      }

      const opInfo = opsInfo?.get(rec.line_id)?.get(rec.operation_id);
      const wInfo = workstationInfo?.get(rec.line_id)?.get(rec.operation_id);
      const operatorInfo = operatorsInfo?.get(rec.line_id)?.get(rec.operator_id);

      const hourWiseGmtTimes = [];
      const key = rec.line_id + '@' + rec.operation_id + '@' + rec.workstation_id;
      const opWrkGmtTimes = perGmtTimeMap.get(key);
      if (opWrkGmtTimes) {
        // This is already in the sorting order
        opWrkGmtTimes.forEach(r => hourWiseGmtTimes.push(r.gmtTime));
      }
      lineOpWorkstationMap.get(rec.line_id).get(rec.operation_id).push(
        new OpportunityOperationWorkstationModel(rec.operation_id, opInfo?.operationDesc, operatorInfo?.operatorName, hourWiseGmtTimes, rec.workstation_id, wInfo?.workstationDesc)
      );
    });

    // construct the response
    const lineOpportunityOpsModels: LineOpportunityOperationsModel[] = [];
    lineOpWorkstationMap.forEach((operationsInfo, l) => {
      const opportunityOperations: OpportunityOperationsModel[] = [];
      operationsInfo.forEach((wInfos, op) => {

        const opInfo = opsInfo?.get(l)?.get(op);
        const wInfo = workstationInfo?.get(l)?.get(op);

        let sz: number = workstationInfo.size;
        let workstationHrWiseGmtTime: number[] = [];
        // initialize the array to 0
        this.unitShiftHours.forEach((hr, index) => {
          workstationHrWiseGmtTime[index] = 0;
        });
        // for each workstation, sum up the gmt times

        wInfos.forEach((w) => {
          w.actualSpentTimePerGmt.forEach((gt, index) => {
            workstationHrWiseGmtTime[index] += gt;
          });
        });
        // now after summing up, iterate and calculate the average
        workstationHrWiseGmtTime.forEach((gmtTime, index) => {
          gmtTime = Math.round(gmtTime / sz);
        })
        opportunityOperations.push(new OpportunityOperationsModel(op, workstationHrWiseGmtTime, opInfo?.operationDesc, wInfos));
      });

      const lineInfo = linesInfo.get(l);
      lineOpportunityOpsModels.push(new LineOpportunityOperationsModel(l, lineInfo?.lineDesc, opportunityOperations))
    });

    return new LineOpportunityOperationsResponse(true, 0, 'Line downtimes retrieved successfully', lineOpportunityOpsModels);
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  async getLineStyleGarmentAndOperationsSmv(req: UnitLineDateRequest): Promise<LineSmvResponse> {
    // get the distinct style from the line_actual_day_track
    const LineSmvModels: LineSmvModel[] = [];
    const query =  await this.lineActualDayTrackEnt.createQueryBuilder('ld')
    .select(' line_id, style_id')
    .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}' `)
    .groupBy('unit_id, plan_date, line_id, style_id')
    const result: {line_id: string, style_id: string}[] = await query.getRawMany();

    const lineStyleIdsMap = new Map<string, Set<string>>();
    result.forEach(rec => {
      if(!lineStyleIdsMap.has(rec.line_id)) {
        lineStyleIdsMap.set(rec.line_id, new Set<string>());
      }
      lineStyleIdsMap.get(rec.line_id).add(rec.style_id);
    });

    for(const [lineId, styleIds] of lineStyleIdsMap) {
      const consumedOps = [];

      const styleSmvModels: StyleSmvModel[] = [];
      for(const styleId of styleIds) {

        const opSmvModels: OperationSmvModel[] = [];
        let gmtSmv = 0;
        const styleOpSmvs = await this.styleOpEnt.find({ select: ['operationId', 'operationSmv'], where: {lineId: lineId, styleId: styleId} });
        styleOpSmvs.forEach(op => {
          if(!consumedOps.includes(op.operationId)) {
            opSmvModels.push(new OperationSmvModel(op.operationId, op.operationSmv));
            gmtSmv += Number(op.operationSmv);
          }
          consumedOps.push(op.operationId);
        });
        styleSmvModels.push(new StyleSmvModel(styleId, gmtSmv, opSmvModels));
      }
      LineSmvModels.push(new LineSmvModel(lineId, lineId, styleSmvModels));
    }
    return new LineSmvResponse(true, 0 , 'Smv retrieved successfully', LineSmvModels);
  }

















  /**
   * gets the styles in the unit
   * @param req 
   * @returns 
   */
  async getStylesInUnit(req: UnitLineDateRequest): Promise<StylesResponse> {
    const unitId = req.unit;
    if(!unitId) {
      throw new ErrorResponse(0, 'Unit is not provided');
    }
    const styleNames = new Set<string>();
    const styles = await this.styleEnt.find({ select: ['id', 'styleId', 'styleDesc', 'styleName', 'targetEff'], where: { unitId: unitId}, order: { styleName: "ASC"} });
    if(styles.length == 0) {
      throw new ErrorResponse(0, 'Styles not found');
    }
    // we dont bother about ids. We update the efficiencies based on the style names
    const styleModels: StyleModel[] = [];
    styles.forEach(s => {
      if(!styleNames.has(s.styleName)) {
        const styleModel = new StyleModel(s.id, s.styleName, s.styleDesc, s.targetEff);
        styleModels.push(styleModel);
        styleNames.add(s.styleName);
      }
    });
    return new StylesResponse(true, 0, 'Styles list retrieved', styleModels);
  }


  /**
   * THIS API IS REFFERED BY EXTERNAL APPLICATIONS 
   * gets rework information for the hour wise, line wise and workstation level
   * @param req 
   * @returns 
   */
  async getHourlyLineWorkstationGoodAndReworkForExternalApps(req: UnitLineDateRequest): Promise<LineWorkStationReworkResponse> {
    // rework for line -> workstation
    const query = await this.lineActualDayTrackEnt.createQueryBuilder('eff')
      .select(` hour, line_id, is_rework, SUM( IF(is_rework = 1, good_quantity, 0) ) as rework_quantity,  SUM( IF(is_rework = 0, good_quantity, 0) ) as good_quantity, workstation_id, operation_id, operator_id `)
      .where(` unit_id = '${req.unit}' AND plan_date = '${req.date}'`)
      .groupBy(` unit_id, plan_date, line_id, workstation_id, operation_id`);
    if (req.isGroupByHour) {
      query.addGroupBy('hour');
    }
    query.orderBy('unit_id, plan_date, line_id');
    query.addOrderBy('rework_quantity', 'DESC');

    const result: { hour: number, line_id: string, is_rework: number, good_quantity: number, total_records: number, rework_quantity: number, workstation_id: string, operation_id: string, operator_id: string }[] = await query.getRawMany();


    const lineIds = new Set<string>();
    const workstationIds = new Set<string>();
    const operatorIds = new Set<string>();
    result.forEach(rec => {
      lineIds.add(rec.line_id);
      workstationIds.add(rec.workstation_id);
      operatorIds.add(rec.operator_id)
    });

    const linesInfo = await this.inaHelperService.getLineInfo(req.unit, Array.from(lineIds));
    const opsInfo = await this.inaHelperService.getOperationsInfo(req.unit);
    const workstationsInfo = await this.inaHelperService.getWorkstationInfo(req.unit);
    const operatorInfo: Map<string, Map<string, OperatorEntity>> = await this.inaHelperService.getOperatorsInfo(req.unit, Array.from(operatorIds));

    const lineWorkstationReworkMap = new Map<string, Map<number, Map<string, OperationReworkModel[]>>>(); // line -> hour -> workstation -> op rework info
    // const lineWorkstationReworkMap = new Map<string, WorkstationReworkModel>();
    // const lineHourWorkstationReworkMap = new Map<string, LineWorkStationReworkModel>();

    result.forEach(rec => {
      const hour = req.isGroupByHour ? rec.hour : 1;

      rec.rework_quantity = Number(rec.rework_quantity);
      rec.good_quantity = Number(rec.good_quantity);

      if (!lineWorkstationReworkMap.has(rec.line_id)) {
        lineWorkstationReworkMap.set(rec.line_id, new Map<number, Map<string, OperationReworkModel[]>>());
      }
      if (!lineWorkstationReworkMap.get(rec.line_id).has(hour)) {
        lineWorkstationReworkMap.get(rec.line_id).set(hour, new Map<string, OperationReworkModel[]>());
      }
      if (!lineWorkstationReworkMap.get(rec.line_id).get(hour).has(rec.workstation_id)) {
        lineWorkstationReworkMap.get(rec.line_id).get(hour).set(rec.workstation_id, []);
      }

      const opInfo = opsInfo?.get(rec.line_id)?.get(rec.operation_id);
      const operatorDetail = operatorInfo?.get(rec.line_id)?.get(rec.operator_id);
      const operatorName = operatorDetail ? operatorDetail?.operatorName : '';
      const operatorId = operatorDetail ? operatorDetail.operatorId : '';
      lineWorkstationReworkMap.get(rec.line_id)?.get(hour)?.get(rec.workstation_id)?.push(
        new OperationReworkModel(rec.operation_id, opInfo?.operationDesc, rec.rework_quantity, 0, hour, operatorName, operatorId, rec.good_quantity)
      );
    });

    // based on the map, construct the response
    const lineReworkModels: LineWorkStationReworkModel[] = [];
    lineWorkstationReworkMap.forEach((hourReworks, lineId) => {
      let totalLineRework = 0;

      const hourReworkModels: HourWiseReworkModel[] = [];
      hourReworks.forEach((workstationRework, hour) => {
        let totalHourRework = 0;

        const workstationReworkModels: WorkstationReworkModel[] = [];
        workstationRework.forEach((opsRework, workstationId) => {
          let totalWorkstationRework = 0;
          opsRework.forEach(opRework => {
            totalWorkstationRework += opRework.totalRework;
          });
          const workstationInfo = workstationsInfo?.get(lineId)?.get(workstationId);
          const workstationReworkModel = new WorkstationReworkModel(workstationId, workstationInfo?.workstationDesc, totalWorkstationRework, opsRework);
          workstationReworkModels.push(workstationReworkModel);

          totalHourRework += totalWorkstationRework;
        });
        const hourReworkModel = new HourWiseReworkModel(totalHourRework, hour, workstationReworkModels);
        hourReworkModels.push(hourReworkModel);

        totalLineRework += totalHourRework;
      });
      const lineInfo = linesInfo.get(lineId);
      const lineReworkModel = new LineWorkStationReworkModel(lineId, lineInfo?.lineDesc, totalLineRework, hourReworkModels);
      lineReworkModels.push(lineReworkModel);
    });
    return new LineWorkStationReworkResponse(true, 0, 'Hourly line and workstation level rework retrieved successfully', lineReworkModels);
  }
  
}


